import { writable } from 'svelte/store';
import type { Writable } from 'svelte/store';

export const showNewsletterModal: Writable<boolean> = writable<boolean>(false);

export const showValidateEmailUpdateModal: Writable<boolean> = writable<boolean>(false);

export const showRatingModal: Writable<boolean> = writable<boolean>(false);
